module.exports = __webpack_public_path__ + "static/media/about17.0ec29aab.webp";